export const compareNullable = <ValueType>(
  a: null | ValueType,
  b: null | ValueType,
  compareFunction: (a: ValueType, b: ValueType) => number,
  nullPosition: "end" | "start" = "end",
) => {
  if (a !== null && b !== null) {
    return compareFunction(a, b);
  } else if (a === null && b === null) {
    return 0;
  }

  if (nullPosition === "start") {
    return a === null ? -1 : 1;
  } else {
    return a === null ? 1 : -1;
  }
};
